export default "__VITE_ASSET__D8vZL39L__"